import { render, staticRenderFns } from "./JobDescriptionCard.vue?vue&type=template&id=76584bb7&scoped=true"
import script from "./JobDescriptionCard.vue?vue&type=script&lang=ts"
export * from "./JobDescriptionCard.vue?vue&type=script&lang=ts"
import style0 from "./JobDescriptionCard.vue?vue&type=style&index=0&id=76584bb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76584bb7",
  null
  
)

export default component.exports